import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './FAQ.css';
import { HiOutlineChevronDown, HiOutlineChevronUp } from 'react-icons/hi';
import ContactBanner from '../../components/Banner/ContactBanner';

const faqData = [
  {
    question: "What is Pharm-Rx?",
    answer: "Pharm-Rx is a trusted importer and distributor of high-quality active ingredients for the pharmaceutical, nutraceutical, personal care, and food industries.",
  },
  {
    question: "How can I contact your team?",
    answer: "You can reach us through our Contact page or by calling our office at (973) 917-1400.",
  },
  {
    question: "What industries do you serve?",
    answer: "We serve the pharmaceutical, nutraceutical, personal care, and food industries.",
  },
  {
    question: "Do you offer international shipping?",
    answer: "Although we focus on the U.S. market, we do offer limited shipping options to Canada and Mexico. Please contact us for more details and product availability.",
  },
  {
    question: "Where can I find more information about your products?",
    answer: "You can explore our product portfolio on the Products page or contact our team for more details.",
  },
  {
    question: "Is Pharm-Rx seeking new freight or shipping services?",
    answer: "We are currently under long-term contracts with our trusted transportation partners and are not seeking new shipping options at this time.",
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className='faq-main-container'>
      <Helmet>
        <title>Frequently Asked Questions | Pharm-Rx</title>
        <meta name="description" content="Find answers to frequently asked questions about Pharm-Rx, including services, products, and more." />
      </Helmet>

      <div className="faq-heading-container">
        <h2 className="faq-heading">Frequently Asked Questions</h2>
      </div>

      <div className="faq-paragraph-container">
        <p className="faq-paragraph">Find answers to some of the most common questions about our services and products.</p>
      </div>

      <div className="faq-image-section">
        <img 
          src="https://st2.depositphotos.com/34031690/41965/v/600/depositphotos_419650252-stock-illustration-vector-illustrations-concept-illustrations-preparing.jpg" 
          alt="FAQ letters vector"
          className="faq-image"
        />
      </div>

      <div className="faq-container">
        {faqData.map((item, index) => (
          <div key={index} className="faq-item">
            <div className="faq-question" onClick={() => toggleFAQ(index)}>
              <h3>{item.question}</h3>
              {activeIndex === index ? <HiOutlineChevronUp /> : <HiOutlineChevronDown />}
            </div>
            {activeIndex === index && <div className="faq-answer">{item.answer}</div>}
          </div>
        ))}
      </div>

      <div>
        <ContactBanner 
          heading="Need More Help?"
          text="If your question wasn't answered, feel free to reach out to us!"
          buttonText="Contact Us"
          link="/contact"
        />
      </div>
    </div>
  );
};

export default FAQ;
